import { render, staticRenderFns } from "./PremiumModalForm.vue?vue&type=template&id=0d390452&scoped=true"
import script from "./PremiumModalForm.vue?vue&type=script&lang=js"
export * from "./PremiumModalForm.vue?vue&type=script&lang=js"
import style0 from "./PremiumModalForm.vue?vue&type=style&index=0&id=0d390452&prod&lang=css"
import style1 from "./PremiumModalForm.vue?vue&type=style&index=1&id=0d390452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d390452",
  null
  
)

export default component.exports